import { Space } from './space.definitions';

export const indentSize = '4 | betweenListItems' satisfies Space;
